import React, { type ComponentType } from 'react';
import EmptyState from '@atlaskit/empty-state';
import type { Props as CreateDialogLoaderProps } from '@atlassian/jira-create-boards-button/src/view/create-dialog-loader/index.tsx';
import type { Props as CreateButtonProps } from '@atlassian/jira-create-boards-button/src/view/stateless-button/index.tsx';
import type { IntlShape } from '@atlassian/jira-intl';
import imageUrl from './assets/board.svg';
import messages from './messages.tsx';

type Props = {
	CreateDialogLoader: ComponentType<CreateDialogLoaderProps>;
	CreateButton: ComponentType<CreateButtonProps>;
	intl: IntlShape;
};

const Empty = (props: Props): React.JSX.Element => {
	const {
		intl: { formatMessage },
		CreateDialogLoader,
		CreateButton,
	} = props;

	return (
		<CreateDialogLoader>
			{(load, isLoading) => (
				<EmptyState
					imageUrl={imageUrl}
					header={formatMessage(messages.header)}
					description={formatMessage(messages.description)}
					isLoading={isLoading}
					primaryAction={<CreateButton onClick={load} isDisabled={isLoading} withSpinner={false} />}
				/>
			)}
		</CreateDialogLoader>
	);
};

export default Empty;
